/* eslint-disable react-hooks/rules-of-hooks */
import { useMutation, useQuery, useQueryClient } from "react-query";
import * as api from "./usedItemsUrls";

const useUsedItemsQuery = {
  useCategories: (query) => useQuery(["usedItemCategories", query], () => api.listCategories(query), { keepPreviousData: true }),
  useCategory: (id) => useQuery(["usedItemCategory", id], () => api.getCategory(id), { enabled: !!id }),
  useItems: (query) => useQuery(["usedItems", query], () => api.listItems(query), { keepPreviousData: true }),
  useItem: (id) => useQuery(["usedItem", id], () => api.getItem(id), { enabled: !!id }),
  usePlans: () => useQuery("usedItemPlans", api.listPlans),
  useSubscriptions: () => useQuery("myUsedItemSubscriptions", api.mySubscriptions),
  useSubscription: (id) => useQuery(["myUsedItemSubscription", id], () => api.mySubscription(id), { enabled: !!id }),
  usePayments: (query) => useQuery(["myUsedItemPayments", query], () => api.myPayments(query)),
  usePayment: (id) => useQuery(["myUsedItemPayment", id], () => api.myPayment(id), { enabled: !!id }),
  useMyItems: (query) => useQuery(["myUsedItems", query], () => api.myItems(query), { keepPreviousData: true }),
  useMyItem: (id) => useQuery(["myUsedItem", id], () => api.myItem(id), { enabled: !!id }),
  useImages: (id) => useQuery(["myUsedItemImages", id], () => api.itemImages(id), { enabled: !!id }),
};

const useMutationAction = (key, fn, invalidations = []) => {
  const queryClient = useQueryClient();
  return useMutation(fn, { onSettled: () => [key, ...invalidations].forEach((queryKey) => queryClient.invalidateQueries(queryKey)) });
};

useUsedItemsQuery.useCreateSubscription = () => useMutationAction("myUsedItemSubscriptions", api.createSubscription);
useUsedItemsQuery.useCreatePayment = () => useMutationAction("myUsedItemPayments", api.createPayment);
useUsedItemsQuery.useCreateItem = () => useMutationAction("myUsedItems", api.createItem, ["usedItems"]);
useUsedItemsQuery.useUpdateItem = () => useMutationAction("myUsedItems", api.updateItem, ["usedItem"]);
useUsedItemsQuery.useDeleteItem = () => useMutationAction("myUsedItems", api.deleteItem);
useUsedItemsQuery.useAddItemImage = () => useMutationAction("myUsedItemImages", api.addItemImage);
useUsedItemsQuery.useDeleteItemImage = () => useMutationAction("myUsedItemImages", api.deleteItemImage);

useUsedItemsQuery.categories = useUsedItemsQuery.useCategories;
useUsedItemsQuery.category = useUsedItemsQuery.useCategory;
useUsedItemsQuery.items = useUsedItemsQuery.useItems;
useUsedItemsQuery.item = useUsedItemsQuery.useItem;
useUsedItemsQuery.plans = useUsedItemsQuery.usePlans;
useUsedItemsQuery.subscriptions = useUsedItemsQuery.useSubscriptions;
useUsedItemsQuery.subscription = useUsedItemsQuery.useSubscription;
useUsedItemsQuery.payments = useUsedItemsQuery.usePayments;
useUsedItemsQuery.payment = useUsedItemsQuery.usePayment;
useUsedItemsQuery.myItems = useUsedItemsQuery.useMyItems;
useUsedItemsQuery.myItem = useUsedItemsQuery.useMyItem;
useUsedItemsQuery.images = useUsedItemsQuery.useImages;
useUsedItemsQuery.createSubscription = useUsedItemsQuery.useCreateSubscription;
useUsedItemsQuery.createPayment = useUsedItemsQuery.useCreatePayment;
useUsedItemsQuery.createItem = useUsedItemsQuery.useCreateItem;
useUsedItemsQuery.updateItem = useUsedItemsQuery.useUpdateItem;
useUsedItemsQuery.deleteItem = useUsedItemsQuery.useDeleteItem;
useUsedItemsQuery.addItemImage = useUsedItemsQuery.useAddItemImage;
useUsedItemsQuery.deleteItemImage = useUsedItemsQuery.useDeleteItemImage;

export default useUsedItemsQuery;
